module.exports = __webpack_public_path__ + "img/number-black-29.c5ba0cc2.png";